module.exports = __webpack_public_path__ + "img/badge-check.e3116577.png";